import React from 'react';

/**
 * CORE-1343 — веб-заглушка слоя свёрнутой сессии.
 *
 * Сворачивание сделано для телефона: в браузере комната и так живёт вкладкой,
 * которую можно оставить открытой, а плитка поверх страницы конкурировала бы с
 * виджетом Agapella и лендинговыми поверхностями. Метро подставляет
 * `.native.tsx` на iOS/Android, сюда попадает только веб.
 */
export const LiveSessionHost: React.FC = () => null;
